<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Daftar Box Masuk
            </h5>
            <hr />
            <b-row class="mb-2">
                <b-col md="3">
                    <b-form-group label="Kode Box" class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="filter.box_code"
                                maxlength="50"
                                @keydown.enter="getItems"
                                placeholder="Cari Kode Box..."
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="No. Resi" class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="filter.box_no_resi"
                                maxlength="50"
                                @keydown.enter="getItems"
                                placeholder="Cari No. Resi..."
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status Penerimaan">
                        <b-form-select
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <div
                            class="d-flex flex-nowrap d-flex justify-content-between"
                        >
                            <b-button variant="primary" @click="getItems">
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data Box.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge
                        :variant="getStatusBadge(row.item.status).variant"
                        :class="getStatusBadge(row.item.status).class"
                    >
                        {{ getStatusBadge(row.item.status).label }}
                    </b-badge>
                </template>

                <template v-slot:cell(delivery)="row">
                    <div v-if="row.item.received_at && row.item.received_by">
                        <div class="small">
                            <strong>Diterima:</strong>
                            {{ row.item.received_by }} -
                            {{ parseDate(row.item.received_at) }}
                        </div>
                    </div>
                    <div v-else class="text-muted">-</div>
                </template>
                <template v-slot:cell(action)="row">
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <router-link
                            :to="
                                '/emas/pengiriman/' +
                                $route.params.deliveryId +
                                '/' +
                                $route.params.batchId +
                                '/' +
                                row.item.id
                            "
                            class="pr-2"
                        >
                            <b-button
                                size="sm"
                                variant="primary"
                                v-b-tooltip.hover.top
                                title="Detail Box"
                            >
                                <i class="fa fa-fw fa-info" />
                            </b-button>
                        </router-link>
                        <b-button
                            size="sm"
                            v-if="
                                row.item.status === 2 && row.item.marked_video_url
                            "
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Lihat Detail Suspect"
                            @click="showModalSuspectBox(row.item)"
                        >
                            <i class="fa fa-fw fa-eye" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <ModalSuspectBox
            ref="modalSuspectBox"
            :item="selectedItem"
            @refresh-items="getItems(currentPage)"
        />
    </div>
</template>

<script>
import ModalSuspectBox from "./ModalSuspectBox.vue";

export default {
    components: {
        ModalSuspectBox
    },
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            filter: {
                box_code: "",
                box_no_resi: "",
                status: -1
            },

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 0, text: "Dalam Pengiriman" },
                { value: 1, text: "Sudah Diterima" },
                { value: 2, text: "Suspect" }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "box_code", label: "Kode Box", sortable: false },
                { key: "box_no_resi", label: "No. Resi", sortable: false },
                { key: "branch", label: "Cabang", sortable: false },
                { key: "total_item", label: "Jumlah Barang", sortable: false },
                {
                    key: "total_dry_weight",
                    label: "Total Berat Kotor",
                    sortable: false
                },
                { key: "status", label: "Status Penerimaan", sortable: false },
                {
                    key: "delivery",
                    label: "Detail Penerimaan",
                    sortable: false
                },
                { key: "action", label: "Aksi", sortable: false }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,

            selectedItem: null
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            const batchId = this.$route.params.batchId;
            param += `&deliveryBatchId=${batchId}`;

            if (this.filter.box_code) {
                param += `&filterCode=${this.filter.box_code}`;
            }

            if (this.filter.box_no_resi) {
                param += `&filterResi=${this.filter.box_no_resi}`;
            }

            if (this.filter.status != -1) {
                param += `&filterStatus=${this.filter.status}`;
            }

            return this.$axios
                .get("gold-deliveries" + param + "&source=PEI")
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        showModalSuspectBox(item) {
            this.selectedItem = item;
            this.$refs.modalSuspectBox.$bvModal.show("m-suspect-box");
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return {
                        variant: "info",
                        label: "DALAM PENGIRIMAN",
                        class: "text-white"
                    };
                case 1:
                    return {
                        variant: "success",
                        label: "SUDAH DITERIMA",
                        class: "text-white"
                    };
                case 2:
                    return {
                        variant: "danger",
                        label: "SUSPECT",
                        class: "text-white"
                    };
            }
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        parseDate(date) {
            if (!date) return "-";

            return `${this.$helper.parseDate(
                date
            )}, ${this.$helper.parseHourMinute(date)}`;
        }
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
